


import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import VerifiedIcon from "@mui/icons-material/Verified";
import PrintIcon from "@mui/icons-material/Print";
import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DoneAllIcon from "@mui/icons-material/DoneAll";

export const invoiceSteps = [
  {
    label: "Validaciones iniciales",
    sub: "Revisando RFC y domicilios",
    tasks: ["Validar RFC emisor", "Validar receptor"],
    icon: <VerifiedIcon fontSize="small" />,
  },
  {
    label: "Armando Factura",
    sub: "Integrando conceptos",
    tasks: ["Generando Documento", "PDF", "XML"],
    icon: <LocalShippingIcon fontSize="small" />,
  },
  {
    label: "Timbrado",
    sub: "Sellando CFDI",
    tasks: ["Timbrar", "Adjuntar Complemento"],
    icon: <PrintIcon fontSize="small" />,
  },
];


export const updateSteps = [
  {
    label: "Escaneo de datos",
    sub: "Obteniendo datos",
    tasks: [
      "Validar RFC",
      "Seleccionar Tipo de Persona",
      "Registrar Régimen Fiscal",
      "Definir Uso de CFDI y Método de Pago",
    ],
    icon: <VerifiedIcon fontSize="small" />,
  },
  {
    label: "Dirección",
    sub: "Asignando ubicación",
    tasks: ["Registrar dirección fiscal", "Validar país, estado y municipio"],
    icon: <LocationOnIcon fontSize="small" />,
  },
  {
    label: "Finalización",
    sub: "Confirmando registro",
    tasks: [
      "Guardar socio de negocio",
      "Validar integración con CFDI",
      "Confirmar datos finales",
    ],
    icon: <DoneAllIcon fontSize="small" />,
  },
];



export const bussinesPartnerSteps = [
  {
    label: "Facturación",
    sub: "Capturando información fiscal",
    tasks: [
      "Validar RFC",
      "Seleccionar Tipo de Persona",
      "Registrar Régimen Fiscal",
      "Definir Uso de CFDI y Método de Pago",
    ],
    icon: <VerifiedIcon fontSize="small" />,
  },
  {
    label: "Generales",
    sub: "Datos del representante legal",
    tasks: [
      "Nombre y apellidos del representante",
      "Correo electrónico",
      "Régimen de capital (si aplica)",
    ],
    icon: <PersonIcon fontSize="small" />,
  },
  {
    label: "Dirección",
    sub: "Asignando ubicación",
    tasks: ["Registrar dirección fiscal", "Validar país, estado y municipio"],
    icon: <LocationOnIcon fontSize="small" />,
  },
  {
    label: "Finalización",
    sub: "Confirmando registro",
    tasks: [
      "Guardar socio de negocio",
      "Validar integración con CFDI",
      "Confirmar datos finales",
    ],
    icon: <DoneAllIcon fontSize="small" />,
  },
];
